var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("About")]),_c('p',[_c('img',{attrs:{"src":"/imgs/logo@2x.png","alt":"potly icon","width":"60","height":"60"}})]),_c('h2',[_vm._v("Potly")]),_c('p',[_vm._v("Potlyは、日常の小さなことを記録して新しい何かを生み出すためのプラットフォーム・アプリです。")])])
}]

export { render, staticRenderFns }